module.exports = __webpack_public_path__ + "static/media/door.73f7950c.svg";